import { heroStats } from '@/mocks/guide';

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20abstract%20background%20with%20warm%20amber%20and%20crimson%20light%20streaks%20over%20deep%20charcoal%20surface%2C%20dramatic%20newspaper%20investigative%20atmosphere%2C%20subtle%20paper%20texture%20and%20soft%20spotlight%20glow%2C%20high%20contrast%20empty%20space%20for%20text%20overlay%2C%20cinematic%20grain%2C%20no%20people%2C%20no%20text&width=1600&height=900&seq=baoliao-hero-01&orientation=landscape"
          alt="爆料51 投稿指南主视觉背景"
          title="爆料51 投稿指南 · 格式要求 渠道流程 注意事项"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/90"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-accent-950/40 via-transparent to-primary-950/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-background-100 text-xs md:text-sm backdrop-blur">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse"></span>
            投稿指南 · 一次说清
          </span>

          <h1 className="mt-6 font-heading font-bold text-background-50 text-3xl sm:text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.15]">
            爆料51 投稿指南
            <span className="block mt-2 text-primary-300">格式要求 · 渠道流程 · 注意事项</span>
          </h1>

          <p className="mt-6 text-background-200 text-base md:text-lg leading-relaxed max-w-2xl">
            想投稿却怕格式不对、流程不清？这份指南把投稿格式、渠道流程与常见注意事项一次性讲明白，帮你避开退稿的高频坑，让线索更完整、更容易被采纳。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4 max-w-lg sm:max-w-none">
            <a
              href="#format"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
            >
              先看格式要求
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
            <a
              href="#submit"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-50/10 border border-background-50/25 text-background-50 font-medium whitespace-nowrap cursor-pointer backdrop-blur transition-colors hover:bg-background-50/20"
            >
              <i className="ri-send-plane-line" aria-hidden="true" />
              直接去投稿
            </a>
          </div>

          <dl className="mt-10 md:mt-14 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-5 max-w-3xl">
            {heroStats.map((stat) => (
              <div key={stat.label} className="border-l-2 border-primary-500 pl-3">
                <dt className="font-heading text-xl md:text-2xl font-bold text-background-50">{stat.value}</dt>
                <dd className="mt-1 text-xs md:text-sm text-background-300 leading-snug">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <a
        href="#highlights"
        aria-label="向下滚动"
        className="hidden md:flex absolute bottom-6 left-1/2 -translate-x-1/2 z-10 w-10 h-10 items-center justify-center rounded-full border border-background-50/30 text-background-100 cursor-pointer hover:bg-background-50/10 transition-colors"
      >
        <i className="ri-arrow-down-line text-lg" aria-hidden="true" />
      </a>
    </section>
  );
}